<section class="faq-section section-gap with-illustration with-shape grey-bg">
  <div class="container">
    <div class="faq-illustration-img">
      <img
        src="assets/img/illustration/03.png"
        alt="illustration"
        data-aos="zoom-in-right"
      />
    </div>
    <div
      class="row justify-content-lg-end justify-content-center"
      *transloco="let t; read: 'home'"
    >
      <div class="col-lg-6 col-md-10">
        <div class="faq-content">
          <div class="section-title mb-40 left-border">
            <!-- <span class="title-tag">FAQ</span> -->
            <h3>{{ t("title5") }}</h3>
          </div>
          <!-- FAQ LOOP -->
          <!-- activeIds="static-1" -->
          <ngb-accordion
            [closeOthers]="true"
            class="accordion faq-loop"
            id="faqAccordion"
          >
            <ngb-panel id="static-1">
              <ng-template ngbPanelTitle>
                {{ t("title_collapse_1") }}
                <span class="icons">
                  <i class="far fa-plus"></i>
                </span>
              </ng-template>
              <ng-template ngbPanelContent
                ><p>
                  {{ t("text_collapse_1") }}
                </p></ng-template
              >
            </ngb-panel>
            <ngb-panel id="static-2">
              <ng-template ngbPanelTitle>
                {{ t("title_collapse_2") }}
                <span class="icons">
                  <i class="far fa-plus"></i>
                </span>
              </ng-template>
              <ng-template ngbPanelContent
                ><p>{{ t("text_collapse_2") }}</p></ng-template
              >
            </ngb-panel>
            <ngb-panel id="static-3">
              <ng-template ngbPanelTitle>
                {{ t("title_collapse_3") }}
                <span class="icons">
                  <i class="far fa-plus"></i>
                </span>
              </ng-template>
              <ng-template ngbPanelContent
                ><p>
                  {{ t("text_collapse_3") }}
                </p></ng-template
              >
            </ngb-panel>
            <ngb-panel id="static-4">
              <ng-template ngbPanelTitle>
                {{ t("title_collapse_4") }}
                <span class="icons">
                  <i class="far fa-plus"></i>
                </span>
              </ng-template>
              <ng-template ngbPanelContent
                ><p>
                  {{ t("text_collapse_4") }}
                </p></ng-template
              >
            </ngb-panel>
          </ngb-accordion>
          <!-- End Faq LOOP -->
        </div>
      </div>
    </div>
    <!-- <div
      class="circle-img"
      style="background-image: url(assets/img/faq-circle.png)"
    ></div> -->
  </div>
</section>
